class SideCart extends HTMLElement {
  static selectors = {
    btnCheckout: '[data-checkout]',
    loader: '[data-ripple]',
  }
  eventsAdded = false;
  offcanvas;
    
  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.btnCheckout = this.querySelector(SideCart.selectors.btnCheckout);
    this.loader = this.querySelector(SideCart.selectors.loader);
    if(!this.offcanvas)
      this.offcanvas = new bootstrap.Offcanvas(this);

    if(this.btnCheckout)
      this.btnCheckout.addEventListener('click', (e) => this.checkout());

    if(!this.eventsAdded){
      window.addEventListener('theme.quantity_adding_cart', (e) => {
        this.loadOpen();
      });
      window.addEventListener('theme.removing_cart', (e) => {
        this.loadOpen();
      });
      window.addEventListener('theme.quantity_added_cart', (e) => {
        this.update();
      });
      window.addEventListener('theme.error_quantity_add_cart', (e) => {
        this.loadClose();
      });
      window.addEventListener('theme.removed_cart', (e) => {
        this.update();
      });
      window.addEventListener('theme.error_remove_cart', (e) => {
        this.loadClose();
      });
      window.addEventListener(Utils.CART_ADDING, (e) => {
        this.loadOpen();
      });
      window.addEventListener(Utils.CART_ADDED, (e) => {
        this.open();
        this.update();
      });
      window.addEventListener(Utils.CART_ADD_ERROR, (e) => {
        this.loadClose();
      });
      this.eventsAdded = true;  
    }
  }

  checkout = () => {
    window.pageLoader.open();
    const form = Utils.getParentByTagName(this.btnCheckout, 'FORM');
    let valid = true;
    form.querySelectorAll('input, select').forEach((input) => {
      valid = valid && input.validity.valid;
    });
    if(valid)
      form.submit();
  }
 
  update = () => {
    axios.get(location.href).then((response) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(response.data, 'text/html');
      this.innerHTML = doc.querySelector('side-cart').innerHTML;
      this.init();
    })
    .catch(function(error) {
      Utils.error(error.message, error);
    })
    .finally(() => {
      this.loadClose();
    });
  }

  loadOpen = () => {
    if(this.loader != undefined){
      this.loader.classList.remove('d-none');
    }
  }

  loadClose = () => {
    if(this.loader != undefined){
      this.loader.classList.add('d-none');
    }
  }

  open = () => {
    this.offcanvas.show();
  }

  close = () => {
    this.offcanvas.hide();
  }

}
if (!window.customElements.get("side-cart")) {
  window.customElements.define("side-cart", SideCart);
}